<template>
  <div>
    <div class="page-title">訂單詳情</div>
    <div class="page-box">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row class="row-list">
        <el-col :span="12"> 訂單編號 : {{ detail.orderNo }}</el-col>
        <el-col :span="12"
          >用戶電郵 : <span v-if="detail.parent">{{ detail.parent.email }}</span>
        </el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12">
          訂單日期 : {{ detail.createdAt | formatDate }}</el-col
        >
        <el-col :span="12">訂單金額 : {{ detail.payPrice }}</el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"
          >付款類型 : {{ detail.payType | paymentType }}</el-col
        >
        <el-col :span="12">付款狀態 : {{ detail.status | payStatus }}</el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12"
          >交易編號 : {{ detail.payId  }}</el-col
        >
        <el-col :span="12">推廣碼 : <span v-if="detail.promotionCode">{{ detail.promotionCode  }}</span><span v-else>--</span></el-col>
      </el-row>
      <el-row class="row-list">
        <el-col :span="12">備註 : <span v-if="detail.remark">{{ detail.remark  }}</span><span v-else>--</span></el-col>
      </el-row>
      <vue-dividing-line title="年級信息"></vue-dividing-line>
      <div>
        <el-table stripe :data="detail.orderItems" style="width: 100%;">
          <el-table-column prop="grade" label="年級"> </el-table-column>
          <el-table-column prop="student" label="學生帳戶名稱">
          </el-table-column>
          <el-table-column prop="startDate" label="訂閱開始時間">
          </el-table-column>
          <el-table-column prop="endDate" label="訂閱結束時間">
          </el-table-column>
          <el-table-column prop="price" label="價格 ($)"> </el-table-column>
          <el-table-column prop="payPrice" label="實付價格($)"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detail: {
        orderNo: "string",
        userId: 0,
        totalPrice: 0,
        status: 0,
        payId: "string",
        payReturnMessage: "string",
        payedAt: "string",
        payType: "string",
        createdAt: "string",
        parent: {
          id: 1,
          userNo: "S001",
          name: "草莓",
          gender: 0,
          email: "staff",
          password: "admin1234",
          confirmPassword: "admin1234",
          areaCode: {
            id: 1,
            code: 0,
          },
          phone: "12345678911",
          roleId: 0,
          avatar: "https://image.baidu.com/search/detail?ct=503316480",
          country: {
            id: 1,
            name: "string",
          },
          area: {
            id: 1,
            name: "string",
            countryId: "string",
          },
          district: {
            id: 1,
            name: "string",
            areaId: "string",
          },
          address: "string",
          students: [
            {
              id: 1,
              userNo: "S001",
              name: "草莓",
              gender: 0,
              branchSchool: {
                id: 1,
                name: {
                  en: "string",
                  zhTc: "string",
                },
                abbreviation: "string",
              },
              password: "student1234",
              confirmPassword: "student1234",
              grade: {
                id: 1,
                name: "string",
                price: 0,
              },
              avatar: "https://image.baidu.com/search/detail?ct=503316480",
              birthday: "2020-11-11",
              studentCode: "string",
            },
          ],
        },
        orderItems: [
          {
            id: 0,
            orderId: 0,
            gradeId: 0,
            parentId: 0,
            studentId: 0,
            price: 0,
          },
        ],
      },
    };
  },
  created() {
    this.getOrderDetail();
  },
  methods: {
    onProgramText(id) {
      this.$router.push({ path: `/order/${id}` });
    },
    getOrderDetail() {
      getOrderDetail(this.id).then((v) => {
        this.detail = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  margin: 20px 0;
  background-color: #fff;
  padding: 20px;
}
.row-list {
  margin-bottom: 10px;
}
</style>